import TopBar from "./components/layouts/TopBar";
import SideBar from "./components/layouts/SideBar";
//import { ColorModeContext, useMode } from "./theme";
//import { CssBaseline, ThemeProvider } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Dashboard } from "./components/screens/dashboard/Dashboard";
import { AppsManage } from "./components/screens/apps_manage/AppsManage";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Teams } from "./components/screens/teams/Teams";
import Gateways from "./components/screens/payout/Gateways";
import GiftCodes from "./components/screens/payout/GiftCodes";
import Analytics from "./components/screens/payout/Analytics";

import UtmReports from "./components/screens/utm/UtmReports";
import Socials from "./components/screens/socials/Socials";
import SetConfigs from "./components/screens/apps_manage/settings/SetConfigs";

import Users from "./components/screens/apps_manage/Users";
import Transactions from "./components/screens/apps_manage/Transactions";
import Reviews from "./components/screens/apps_manage/Reviews";
import Devices from "./components/screens/apps_manage/Devices";
import Callback from "./components/screens/apps_manage/settings/Callback";
import PayoutSetting from "./components/screens/apps_manage/settings/PayoutSetting";
import RedirectSetting from "./components/screens/apps_manage/settings/RedirectSetting";
import WithdrawSetting from "./components/screens/apps_manage/settings/WithdrawSetting";
import LandingPage from "./components/screens/apps_manage/website/LandingPage";
import PrivacyPolicy from "./components/screens/apps_manage/website/PrivacyPolicy";
import Deeplink from "./components/screens/apps_manage/website/Deeplink";
import WebsiteSetting from "./components/screens/apps_manage/website/WebsiteSetting";

import Rule from "./components/screens/apps_manage/website/Rule";
import Server from "./components/screens/apps_manage/Server";
import Notes from "./components/screens/apps_manage/Notes";
import AnalyticsApp from "./components/screens/apps_manage/AnalyticsApp";
import Account from "./components/screens/apps_manage/account/Account";
import Profile from "./components/screens/apps_manage/account/Profile";
import AddCallback from "./components/screens/apps_manage/settings/AddCallback";
import Notification from "./components/screens/notification/Notification";
import Pages from "./components/screens/apps_manage/settings/Pages";
import AppConfig from "./components/screens/apps_manage/website/AppConfig";
import BonusSetting from "./components/screens/apps_manage/settings/BonusSetting";
import Login from "./components/screens/apps_manage/account/Login";
import PrivateRoute from "./components/util/PrivateRoute";
import { AuthContext, AuthProvider } from "./components/util/AuthContext";
import { Toaster } from "react-hot-toast";
import Media from "./components/screens/media/Images";
import Images from "./components/screens/media/Images";
import PayoutTrans from "./components/screens/payout/PayoutTrans";
import GiftCards from "./components/screens/payout/GiftCards";
import PayoutConfigs from "./components/screens/payout/PayoutConfigs";
import UserTransactions from "./components/screens/apps_manage/UserTransactions";
import SocialsConfig from "./components/screens/apps_manage/settings/SocialsConfig";
import SponsorApps from "./components/screens/sponsor_apps/SponsorApps";
import SponsorAppsConfig from "./components/screens/sponsor_apps/SponsorAppsConfig";
import SystemSettings from "./components/screens/system/SystemSettings";
import AdRevanue from "./components/screens/ad_revanue/AdRevenue";
import AdRevenue from "./components/screens/ad_revanue/AdRevenue";
import Influncer from "./components/screens/socials/Influencer";
import Influencer from "./components/screens/socials/Influencer";
import InfluencerInfo from "./components/screens/socials/InfluencerInfo";
import GameManage from "./components/screens/apps_manage/games/GameManage";

function App() {
  const [sideBarCollapseed, setSideBarCollapsed] = useState(false);
  //const [currentPage, setCurrentPage] = useState("dashboard");

  const [isHome, setHome] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  // Get auth state from context
  const { user } = useContext(AuthContext);
  const isAuthenticated = !!user;

  // Derive `isHome` from the current route so it persists across refreshes.
  useEffect(() => {
    if (location.pathname.startsWith("/apps")) {
      setHome(false);
    } else {
      setHome(true);
    }
  }, [location.pathname]);

  //const toggleHome = () => setHome((s) => !s);

    const pageRoutes = {
    Dashboard: "/dashboard",
    "User Overview": "/users",
    "Payout Overview": "/payout",
    "General Settings": "/settings",
    "Profile Settings": "/profile",
    Security: "/security",
  };

  return (
    // <ColorModeContext.Provider value={colorMode}>
    // <ThemeProvider theme={theme}>
    // <CssBaseline/>

    <div
      className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50
          to-indigo-50 dark:from-slate-900 dark:via-slate-900/95 
    dark:to-slate-900 transition-all duration-500"
    >
      <Toaster />
      <div className="flex h-screen overflow-hidden">
        {isAuthenticated && (
          <SideBar
            collapsed={sideBarCollapseed}
            isHome={isHome}
            onToggleHome={() => {
              setHome(true);
              navigate("/apps");
            }}
          />
        )}

        <div className="flex-1 flex flex-col overflow-hidden">
          {isAuthenticated && (
            <TopBar
              onToggleSideBar={() => setSideBarCollapsed(!sideBarCollapseed)}
            />
          )}

          <main className="flex-1 overflow-y-auto bg-transparent">
            <div className="p-6 space-y-6">
              <Routes>
                <Route path="/login" element={<Login />} />

                <Route element={<PrivateRoute />}>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/" element={<Dashboard />} />
                  <Route
                    path="/apps"
                    element={
                      <AppsManage
                        onToggleHome={() => {
                          // entering app view: mark not-home so app routes render
                          // leaving home: mark home so app routes don't render
                          setHome(false);
                        }}
                      />
                    }
                  />
                  {/* Account */}
                  <Route path="/apps/:id/users/:uuid" element={<Profile />} />
                  <Route
                    path="/apps/:id/users/:user_id/"
                    element={<Profile />}
                  />

                  <Route path="/teams" element={<Teams />} />
                  <Route path="/notification" element={<Notification />} />
                  {/* payout---------------- */}
                  <Route path="/payout/gateways" element={<Gateways />} />
                  <Route path="/payout/giftcodes" element={<GiftCodes />} />
                  <Route path="/payout/giftcodes/:id" element={<GiftCards />} />
                  <Route path="/payout/analytics" element={<Analytics />} />
                  <Route
                    path="/payout/transactions"
                    element={<PayoutTrans />}
                  />
                  <Route path="/payout/configs" element={<PayoutConfigs />} />

                  <Route path="/utm/" element={<UtmReports />} />
                  <Route path="/socials/" element={<Socials />} />
                  <Route path="/ads_revenue" element={<AdRevenue />} />
                  <Route path="/sponsor_apps/" element={<SponsorApps />} />
                  <Route path="/Games" element={<GameManage />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/media/images" element={<Images />} />
                  <Route path="/system/settings" element={<SystemSettings />} />
                  <Route path="/influencer/" element={<Influencer />} />
                  <Route path="/influencer/info" element={<InfluencerInfo />} />


                  {/* App Base */}
                  <Route
                    path="/apps/:id/analytics"
                    element={<AnalyticsApp />}
                  />
                  <Route path="/apps/:id/users" element={<Users />} />
                  <Route
                    path="/apps/:id/transactions"
                    element={<Transactions />}
                  />
                  <Route
                    path="/apps/:id/transactions/:user_id"
                    element={<UserTransactions />}
                  />
                  <Route path="/apps/:id/reviews" element={<Reviews />} />
                  <Route path="/apps/:id/devices" element={<Devices />} />
                  <Route path="/apps/:id/rule" element={<Rule />} />
                  <Route path="/apps/:id/server" element={<Server />} />
                  <Route path="/apps/:id/note" element={<Notes />} />
                  <Route path="/apps/:id" element={<AppsManage />} />
                  {/* App Settings */}
                  <Route
                    path="/apps/:id/settings/configs"
                    element={<SetConfigs />}
                  />
                  <Route
                    path="/apps/:id/settings/callback"
                    element={<Callback />}
                  />
                  <Route
                    path="/apps/:id/settings/callback/add"
                    element={<AddCallback />}
                  />
                  <Route
                    path="/apps/:id/settings/bonus"
                    element={<BonusSetting />}
                  />
                  <Route
                    path="/apps/:id/settings/payout"
                    element={<PayoutSetting />}
                  />
                  <Route
                    path="/apps/:id/settings/redirect"
                    element={<RedirectSetting />}
                  />
                  <Route
                    path="/apps/:id/settings/withdrawal"
                    element={<WithdrawSetting />}
                  />
                  <Route
                    path="/apps/:id/settings/socials"
                    element={<SocialsConfig />}
                  />
                  <Route
                    path="/apps/:id/settings/sponsor_apps"
                    element={<SponsorAppsConfig />}
                  />
                  {/* App Website */}
                  <Route
                    path="/apps/:id/website/app-config"
                    element={<AppConfig />}
                  />
                  <Route path="/apps/:id/website/pages" element={<Pages />} />
                  <Route
                    path="/apps/:id/website/landing"
                    element={<LandingPage />}
                  />
                  <Route
                    path="/apps/:id/website/privacy"
                    element={<PrivacyPolicy />}
                  />
                  <Route
                    path="/apps/:id/website/deeplink"
                    element={<Deeplink />}
                  />
                  <Route
                    path="/apps/:id/website/setting"
                    element={<WebsiteSetting />}
                  />

                  <Route path="*" element={<div>404 Not Found</div>} />
                </Route>
              </Routes>
            </div>
          </main>
        </div>
      </div>
    </div>

    //</ThemeProvider>
    //</ColorModeContext.Provider>
  );
}

export default App;
